import { PluginGeneratedSerialDescriptorqdzeg5asqhfg as PluginGeneratedSerialDescriptor } from './PluginGeneratedSerialDescriptor.mjs';
import { contentEqualsaf55p28mnw74 as contentEquals } from '../../../../kotlin-kotlin-stdlib/kotlin/collections/_ArraysJs.mjs';
import {
  equals2au1ep9vhcato as equals,
  toString1pkumu07cwy4m as toString,
  protoOf180f3jzyo7rfj as protoOf,
} from '../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { IllegalStateExceptionkoljg5n0nrlr as IllegalStateException } from '../../../../kotlin-kotlin-stdlib/kotlin/exceptions.mjs';
import {
  typeParametersSerializers2likxjr48tr7y as typeParametersSerializers,
  GeneratedSerializer1f7t7hssdd2ws as GeneratedSerializer,
} from './PluginHelperInterfaces.mjs';
//region block: imports
var imul = Math.imul;
//endregion
//region block: pre-declaration
//endregion
var InlineClassDescriptorClass;
function InlineClassDescriptor() {
  if (InlineClassDescriptorClass === VOID) {
    class $ extends PluginGeneratedSerialDescriptor() {
      constructor(name, generatedSerializer) {
        super(name, generatedSerializer, 1);
        this.isInline_1 = true;
      }
      get_isInline_usk17w_k$() {
        return this.isInline_1;
      }
      hashCode() {
        return imul(super.hashCode(), 31);
      }
      equals(other) {
        var tmp$ret$0;
        $l$block_5: {
          // Inline function 'kotlinx.serialization.internal.equalsImpl' call
          if (this === other) {
            tmp$ret$0 = true;
            break $l$block_5;
          }
          if (!(other instanceof InlineClassDescriptor())) {
            tmp$ret$0 = false;
            break $l$block_5;
          }
          if (!(this.get_serialName_u2rqhk_k$() === other.get_serialName_u2rqhk_k$())) {
            tmp$ret$0 = false;
            break $l$block_5;
          }
          if (!(other.isInline_1 && contentEquals(this.get_typeParameterDescriptors_3o94ow_k$(), other.get_typeParameterDescriptors_3o94ow_k$()))) {
            tmp$ret$0 = false;
            break $l$block_5;
          }
          if (!(this.get_elementsCount_288r0x_k$() === other.get_elementsCount_288r0x_k$())) {
            tmp$ret$0 = false;
            break $l$block_5;
          }
          var inductionVariable = 0;
          var last = this.get_elementsCount_288r0x_k$();
          if (inductionVariable < last)
            do {
              var index = inductionVariable;
              inductionVariable = inductionVariable + 1 | 0;
              if (!(this.getElementDescriptor_ncda77_k$(index).get_serialName_u2rqhk_k$() === other.getElementDescriptor_ncda77_k$(index).get_serialName_u2rqhk_k$())) {
                tmp$ret$0 = false;
                break $l$block_5;
              }
              if (!equals(this.getElementDescriptor_ncda77_k$(index).get_kind_wop7ml_k$(), other.getElementDescriptor_ncda77_k$(index).get_kind_wop7ml_k$())) {
                tmp$ret$0 = false;
                break $l$block_5;
              }
            }
             while (inductionVariable < last);
          tmp$ret$0 = true;
        }
        return tmp$ret$0;
      }
    }
    initMetadataForClass($, 'InlineClassDescriptor');
    InlineClassDescriptorClass = $;
  }
  return InlineClassDescriptorClass;
}
function InlinePrimitiveDescriptor(name, primitiveSerializer) {
  return new (InlineClassDescriptor())(name, new (InlinePrimitiveDescriptor$1())(primitiveSerializer));
}
var InlinePrimitiveDescriptor$1Class;
function InlinePrimitiveDescriptor$1() {
  if (InlinePrimitiveDescriptor$1Class === VOID) {
    class $ {
      constructor($primitiveSerializer) {
        this.$primitiveSerializer_1 = $primitiveSerializer;
      }
      childSerializers_5ghqw5_k$() {
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        return [this.$primitiveSerializer_1];
      }
      get_descriptor_wjt6a0_k$() {
        // Inline function 'kotlin.error' call
        var message = 'unsupported';
        throw IllegalStateException().new_kotlin_IllegalStateException_w47ei6_k$(toString(message));
      }
      serialize_5ase3y_k$(encoder, value) {
        // Inline function 'kotlin.error' call
        var message = 'unsupported';
        throw IllegalStateException().new_kotlin_IllegalStateException_w47ei6_k$(toString(message));
      }
      deserialize_sy6x50_k$(decoder) {
        // Inline function 'kotlin.error' call
        var message = 'unsupported';
        throw IllegalStateException().new_kotlin_IllegalStateException_w47ei6_k$(toString(message));
      }
    }
    protoOf($).typeParametersSerializers_fr94fx_k$ = typeParametersSerializers;
    initMetadataForClass($, VOID, VOID, VOID, [GeneratedSerializer()]);
    InlinePrimitiveDescriptor$1Class = $;
  }
  return InlinePrimitiveDescriptor$1Class;
}
//region block: exports
export {
  InlineClassDescriptor as InlineClassDescriptor2odlvyasjrmr0,
  InlinePrimitiveDescriptor as InlinePrimitiveDescriptor3i6ccn1a4fw94,
};
//endregion

//# sourceMappingURL=InlineClassDescriptor.mjs.map
